import client from "../../../api/client";

export default async function reverseGeocode(payload) {
    const response = await client.post("/location/reverse-geocode", payload);
    return response?.data;
}